import type { ApiSitterSearchConfig } from '@app/constants/ApiTypes/internalEntities'

import { RATE_RANGE_DELTA, RATE_RANGE_MIN_RATE } from './constants'

export class RangeRelativeConverter {
  toRelative(value: number) {
    return (value - RATE_RANGE_MIN_RATE) / RATE_RANGE_DELTA
  }
}

export class RangeToCurrencyConverter {
  private relativeConverter = new RangeRelativeConverter()

  readonly min: number
  readonly max: number
  readonly currency: string
  readonly delta: number
  readonly step: number

  private rounder: number

  constructor(config: ApiSitterSearchConfig) {
    this.min = parseFloat(config.attributes.min_rate)
    this.max = parseFloat(config.attributes.max_rate)
    this.delta = this.max - this.min
    this.step = parseFloat(config.attributes.rate_step)
    this.currency = config.attributes.currency
    this.rounder = 1 / this.step
  }

  toCurrencyValue(value: number) {
    const val = this.relativeConverter.toRelative(value) * this.delta + this.min
    return Math.round(val / this.rounder) * this.rounder
  }
}
